module.exports = __webpack_public_path__ + "img/20210909103113321lj2.de29ff77.png";